<template>
   <div class="section section-contacts" id="section-contacts" v-if="contacts != null" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="container">
            <div class="section-title-page">
                <h4>{{contacts.section}}</h4>
                <h2>{{contacts.title}}</h2>
            </div>
            <div class="number-of-section">
                <span>10</span>
            </div>
            <div class="elem-decor">
                <img :src="contacts.decor" alt="">
            </div>
        </div>
        <div class="map-container-main">
            <!-- MAP -->
            <div class="map-container">
                <div class="map" id='Ymap'></div>
            </div>
            <!-- END MAP -->
        </div>
        <div class="container">
            <div class="map-information">
                <!-- map-navigation -->
                <div class="contacts-tabs-navigation">
                    <ul class="nav nav-tabs">
                        <li v-for="(item, index) in contacts.sales_office" :key="index" :class="{ 'active': index === 0 }">
                            <a :href="'#tabContactsId' + index" data-toggle="tab" :data-lat="item.city_map_lat" :data-lng="item.city_map_lng"><span>{{item.city}}</span></a>
                        </li>
                    </ul>
                </div>
                <!-- end map-navigation -->
                <!-- map-information -->
                <div class="tab-content office-tab-content">
                    <div v-for="(tab,index) in contacts.sales_office" :key="index" class="tab-pane" :class="{ 'active': index === 0 }" :id="'tabContactsId' + index">
                        <div class="sales-item">
                            <div class="office-items">
                                <div class="sales-office" v-for="(office, index) in tab.sales_office_items" :key="index">
                                    <svg-icon icon-class="map_pin" className="icon-map_pin"/>
                                    <a href="#" :data-lat="office.map_lat" :data-lng="office.map_lng">
                                        <p>{{office.adres}}</p>
                                        <h4>{{office.name}}</h4>
                                    </a>
                                </div>
                            </div>
                            <div class="office-info">
                                <div class="phone-of-office">
                                    <!-- <svg-icon icon-class="phone" className="icon-phone"/> -->
                                    <p><span>{{tab.phone_group.phone_code}}</span>{{tab.phone_group.phone}}</p>
                                </div>
                                <div class="company-link">
                                    <!-- <svg-icon icon-class="map_bazis" className="icon-map_bazis"/> -->
                                    <a :href="contacts.bazis_link_group.link" target="_blank">{{contacts.bazis_link_group.name}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end map-information -->
            </div>
        </div>

        <!-- <div class="contacts-tabs">
            <div class="contacts-tabs-content">
                <div class="container">
                    <div class="col-right">
                        <div class="mobile-map-description">
                            <svg-icon icon-class="move" className="icon-move"/>
                            <p>Используйте название офисов продаж как переключатели по карте</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

   </div>
</template>

<script>
    export default {
        name: 'Contacts',
        components: {
        },
        data () {
            return {
                assets: [],
                zoom: 13,
                isMobile: false,
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.15,0.55]
                }
            }
        },
        computed: {
            contacts () {
                return this.$store.state.contacts
            },
            setup () {
                return this.$store.state.pageSetup
            },
            about() {
                return this.$store.state.about.about_fifth_elem
            }
        },
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('active');
                }
            },
            isMobileCheck() {
                var checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                if (checkMobile) {
                    this.isMobile = true
                }
            },
            initYmapScript() {
                let recaptchaScript = document.createElement('script')
                recaptchaScript.setAttribute('src', 'https://api-maps.yandex.ru/2.1/?apikey=c3405fa4-f300-420a-a2f0-af156d16e7f1&lang=ru_RU')
                document.head.appendChild(recaptchaScript)
            },
            mapInit() {
                var location = this.contacts.sales_office;
                var marker = this.contacts.pin_image;
                var zoom = this.zoom;
                var offset = 300;
                var links = $('.sales-office');
                var navTabs = $('.contacts-tabs-navigation .nav-tabs li a');
                ymaps.ready(function () {
                    var i;
                    var pin;
                    var Ymap = new ymaps.Map('Ymap', {
                        center: [location[0].city_map_lng,location[0].city_map_lat],
                        zoom: zoom,
                        controls: ['fullscreenControl',],
                        behaviors: ["drag", "dblClickZoom", "rightMouseButtonMagnifier", "multiTouch"]
                    },{suppressMapOpenBlock: true});
                    Ymap.controls.add('zoomControl', {position: {right: '10px', top: '100px'}});

                    for (i = 0; i < location.length; i++) {
                        for (pin = 0; pin < location[i].sales_office_items.length; pin++) {
                            var lat = location[i].sales_office_items[pin].map_lat,
                                lng = location[i].sales_office_items[pin].map_lng,
                                adres = location[i].sales_office_items[pin].adres,
                                name = location[i].sales_office_items[pin].name;
                            Ymap.geoObjects.add(new ymaps.Placemark([lng,lat], {
                                hintContent: 
                                    '<div style="text-align:center"><p>' + adres + '</p>' +
                                    '<p>' + name + '</p></div>',
                            }, {
                                iconLayout: 'default#image',
                                iconImageHref: marker,
                                iconImageSize: [60, 75],
                                iconImageOffset: [-20, -50]
                            }))
                        }
                    }
                    links.each(function(i,elem){
                        var _self = $(elem).find('a');
                        _self.on('click', function(e){
                            e.preventDefault();
                            var lat = $(this).data('lat'),
                                lng = $(this).data('lng');
                            Ymap.panTo([lng,lat], {
                                safe: false,
                                smooth: true,
                                flying: false,
                                duration: 600
                            }).then(function() {
                                Ymap.setZoom(17, { 
                                    smooth: true
                                });
                                setCenterOffset();

                            })
                        })
                    });
                    navTabs.on('click', function(e){
                        var lat = $(this).data('lat'),
                            lng = $(this).data('lng');
                        Ymap.setCenter([lng,lat]);
                        Ymap.setZoom(zoom);
                    })
                    
                });
            },
            checkMobile() {
                var _self = this;
                if ($(window).width() <= 740) {
                    _self.zoom = 12;
                }
            }
        },
        mounted () {
            this.isMobileCheck();
            this.initYmapScript();
            this.checkMobile();
            this.$store.watch(
                (state) => state.contacts,
                (newValue) => {
                    if (newValue != null) {
                        var _self = this;
                        this.mapInit();
                    }
                }
            )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/contacts/contacts.scss';
    @import '@/styles/components/contacts/contacts-respond.scss';
    // @import '@/styles/components/animation/animation-contacts.scss';
</style>